module.exports = __webpack_public_path__ + "0da8b70cbf157e41376238ccebe85c55.png";